var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ql-snow"},[_c('div',{staticClass:"content-box ql-editor",style:('padding-top:' +
      _vm.config.property_data.margin_top +
      'px;padding-bottom:' +
      _vm.config.property_data.margin_bottom +
      'px;padding-left:' +
      _vm.config.property_data.margin_left +
      'px;padding-right:' +
      _vm.config.property_data.margin_right +
      'px;'),domProps:{"innerHTML":_vm._s(_vm.config.property_data.content || '请输入内容')}})])}
var staticRenderFns = []

export { render, staticRenderFns }